import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const I18N = {
  it: {
    title: 'La sua conversazione con Holiday World',
    callOf: 'Chiamata del',
    operator: 'Operatore',
    gate: 'Per visualizzare la trascrizione completa, ci lasci prima un rapido giudizio sulla conversazione:',
    tap: 'Tocca una stella per valutare',
    commentLabel: 'Vuoi dirci di più? (facoltativo)',
    commentPh: 'Il suo commento...',
    submit: 'Invia e mostra la trascrizione',
    gateVote: 'Ci lasci un rapido giudizio sulla sua conversazione con noi:',
    submitVote: 'Invia il voto',
    showTx: '📄 Mostra anche la trascrizione completa',
    sending: 'Invio in corso...',
    thanks: 'Grazie per il suo giudizio!',
    summaryTitle: 'In sintesi',
    transcriptTitle: 'Trascrizione completa',
    pdf: '📄 Scarica PDF',
    emailAsk: 'Vuole ricevere riepilogo e trascrizione anche via email?',
    emailPh: 'la-sua-email@esempio.com',
    emailBtn: 'Inviami l\'email',
    emailSending: 'Invio...',
    emailSent: '✓ Email inviata! Controlli la sua casella (anche lo spam).',
    emailErr: 'Invio non riuscito, verifichi l\'indirizzo e riprovi.',
    google: 'Le è stato utile? Ci farebbe piacere una recensione su Google',
    googleBtn: '⭐ Lascia una recensione',
    expired: 'Questo link è scaduto (validità 30 giorni). Per ricevere la trascrizione scriva a',
    invalid: 'Link non valido.',
    aiNote: 'Trascrizione generata automaticamente dalla registrazione della chiamata, come annunciato a inizio telefonata. Riepilogo e trascrizione sono realizzati con l\'ausilio dell\'intelligenza artificiale: alcuni termini o concetti potrebbero non essere riportati in modo perfettamente fedele alla conversazione.',
    privacy: 'Informativa privacy',
    error: 'Si è verificato un errore, riprovi tra qualche istante.',
  },
  en: {
    title: 'Your conversation with Holiday World',
    callOf: 'Call of',
    operator: 'Operator',
    gate: 'To view the full transcript, please first leave a quick rating of the conversation:',
    tap: 'Tap a star to rate',
    commentLabel: 'Anything to add? (optional)',
    commentPh: 'Your comment...',
    submit: 'Send and show transcript',
    gateVote: 'Please leave a quick rating of your conversation with us:',
    submitVote: 'Send rating',
    showTx: '📄 Also show the full transcript',
    sending: 'Sending...',
    thanks: 'Thank you for your rating!',
    summaryTitle: 'In short',
    transcriptTitle: 'Full transcript',
    pdf: '📄 Download PDF',
    emailAsk: 'Would you like to receive the summary and transcript by email too?',
    emailPh: 'your-email@example.com',
    emailBtn: 'Send me the email',
    emailSending: 'Sending...',
    emailSent: '✓ Email sent! Please check your inbox (and spam folder).',
    emailErr: 'Sending failed, please check the address and try again.',
    google: 'Was it helpful? We would love a Google review',
    googleBtn: '⭐ Leave a review',
    expired: 'This link has expired (valid 30 days). To receive the transcript, please write to',
    invalid: 'Invalid link.',
    aiNote: 'Transcript generated automatically from the call recording, as announced at the beginning of the call. The summary and transcript are produced with the help of artificial intelligence: some terms or concepts may not perfectly reflect the conversation.',
    privacy: 'Privacy policy',
    error: 'Something went wrong, please try again shortly.',
  },
  de: {
    title: 'Ihr Gespräch mit Holiday World',
    callOf: 'Anruf vom',
    operator: 'Mitarbeiter',
    gate: 'Um das vollständige Transkript zu sehen, bitten wir Sie zunächst um eine kurze Bewertung des Gesprächs:',
    tap: 'Tippen Sie auf einen Stern zum Bewerten',
    commentLabel: 'Möchten Sie uns mehr sagen? (optional)',
    commentPh: 'Ihr Kommentar...',
    submit: 'Senden und Transkript anzeigen',
    gateVote: 'Bitte geben Sie uns eine kurze Bewertung Ihres Gesprächs mit uns:',
    submitVote: 'Bewertung senden',
    showTx: '📄 Auch das vollständige Transkript anzeigen',
    sending: 'Wird gesendet...',
    thanks: 'Vielen Dank für Ihre Bewertung!',
    summaryTitle: 'Kurz zusammengefasst',
    transcriptTitle: 'Vollständiges Transkript',
    pdf: '📄 PDF herunterladen',
    emailAsk: 'Möchten Sie Zusammenfassung und Transkript auch per E-Mail erhalten?',
    emailPh: 'ihre-email@beispiel.de',
    emailBtn: 'E-Mail senden',
    emailSending: 'Senden...',
    emailSent: '✓ E-Mail gesendet! Bitte prüfen Sie Ihr Postfach (auch den Spam-Ordner).',
    emailErr: 'Senden fehlgeschlagen, bitte Adresse prüfen und erneut versuchen.',
    google: 'War es hilfreich? Wir würden uns über eine Google-Bewertung freuen',
    googleBtn: '⭐ Bewertung abgeben',
    expired: 'Dieser Link ist abgelaufen (30 Tage gültig). Um das Transkript zu erhalten, schreiben Sie an',
    invalid: 'Ungültiger Link.',
    aiNote: 'Transkript automatisch aus der Gesprächsaufzeichnung erstellt, wie zu Beginn des Anrufs angekündigt. Zusammenfassung und Transkript werden mit Hilfe künstlicher Intelligenz erstellt; einzelne Begriffe oder Inhalte können vom tatsächlichen Gespräch abweichen.',
    privacy: 'Datenschutzerklärung',
    error: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es gleich erneut.',
  },
  fr: {
    title: 'Votre conversation avec Holiday World',
    callOf: 'Appel du',
    operator: 'Opérateur',
    gate: 'Pour voir la transcription complète, laissez-nous d\'abord une rapide évaluation de la conversation :',
    tap: 'Touchez une étoile pour noter',
    commentLabel: 'Souhaitez-vous en dire plus ? (facultatif)',
    commentPh: 'Votre commentaire...',
    submit: 'Envoyer et afficher la transcription',
    gateVote: 'Laissez-nous une rapide évaluation de votre conversation avec nous :',
    submitVote: 'Envoyer la note',
    showTx: '📄 Afficher aussi la transcription complète',
    sending: 'Envoi en cours...',
    thanks: 'Merci pour votre évaluation !',
    summaryTitle: 'En résumé',
    transcriptTitle: 'Transcription complète',
    pdf: '📄 Télécharger le PDF',
    emailAsk: 'Souhaitez-vous recevoir le résumé et la transcription aussi par e-mail ?',
    emailPh: 'votre-email@exemple.com',
    emailBtn: 'Envoyer l\'e-mail',
    emailSending: 'Envoi...',
    emailSent: '✓ E-mail envoyé ! Vérifiez votre boîte de réception (et les spams).',
    emailErr: 'Échec de l\'envoi, vérifiez l\'adresse et réessayez.',
    google: 'Cela vous a été utile ? Nous serions ravis d\'un avis sur Google',
    googleBtn: '⭐ Laisser un avis',
    expired: 'Ce lien a expiré (validité 30 jours). Pour recevoir la transcription, écrivez à',
    invalid: 'Lien non valide.',
    aiNote: 'Transcription générée automatiquement à partir de l\'enregistrement de l\'appel, comme annoncé en début d\'appel. Le résumé et la transcription sont réalisés à l\'aide de l\'intelligence artificielle : certains termes ou concepts peuvent ne pas refléter parfaitement la conversation.',
    privacy: 'Politique de confidentialité',
    error: 'Une erreur est survenue, veuillez réessayer dans quelques instants.',
  },
  es: {
    title: 'Su conversación con Holiday World',
    callOf: 'Llamada del',
    operator: 'Operador',
    gate: 'Para ver la transcripción completa, déjenos primero una valoración rápida de la conversación:',
    tap: 'Toque una estrella para valorar',
    commentLabel: '¿Quiere contarnos más? (opcional)',
    commentPh: 'Su comentario...',
    submit: 'Enviar y mostrar la transcripción',
    gateVote: 'Déjenos una valoración rápida de su conversación con nosotros:',
    submitVote: 'Enviar valoración',
    showTx: '📄 Mostrar también la transcripción completa',
    sending: 'Enviando...',
    thanks: '¡Gracias por su valoración!',
    summaryTitle: 'En resumen',
    transcriptTitle: 'Transcripción completa',
    pdf: '📄 Descargar PDF',
    emailAsk: '¿Desea recibir el resumen y la transcripción también por correo electrónico?',
    emailPh: 'su-email@ejemplo.com',
    emailBtn: 'Enviarme el email',
    emailSending: 'Enviando...',
    emailSent: '✓ ¡Email enviado! Revise su bandeja de entrada (y el spam).',
    emailErr: 'Envío fallido, verifique la dirección e inténtelo de nuevo.',
    google: '¿Le ha sido útil? Nos encantaría una reseña en Google',
    googleBtn: '⭐ Dejar una reseña',
    expired: 'Este enlace ha caducado (válido 30 días). Para recibir la transcripción escriba a',
    invalid: 'Enlace no válido.',
    aiNote: 'Transcripción generada automáticamente a partir de la grabación de la llamada, como se anunció al inicio. El resumen y la transcripción se realizan con ayuda de inteligencia artificial: algunos términos o conceptos podrían no reflejar fielmente la conversación.',
    privacy: 'Política de privacidad',
    error: 'Se ha producido un error, inténtelo de nuevo en unos instantes.',
  },
  pt: {
    title: 'A sua conversa com a Holiday World',
    callOf: 'Chamada de',
    operator: 'Operador',
    gate: 'Para ver a transcrição completa, deixe-nos primeiro uma avaliação rápida da conversa:',
    tap: 'Toque numa estrela para avaliar',
    commentLabel: 'Quer dizer-nos mais? (opcional)',
    commentPh: 'O seu comentário...',
    submit: 'Enviar e mostrar a transcrição',
    gateVote: 'Deixe-nos uma avaliação rápida da sua conversa connosco:',
    submitVote: 'Enviar avaliação',
    showTx: '📄 Mostrar também a transcrição completa',
    sending: 'A enviar...',
    thanks: 'Obrigado pela sua avaliação!',
    summaryTitle: 'Em resumo',
    transcriptTitle: 'Transcrição completa',
    pdf: '📄 Descarregar PDF',
    emailAsk: 'Deseja receber o resumo e a transcrição também por email?',
    emailPh: 'o-seu-email@exemplo.com',
    emailBtn: 'Enviar-me o email',
    emailSending: 'A enviar...',
    emailSent: '✓ Email enviado! Verifique a sua caixa de entrada (e o spam).',
    emailErr: 'Falha no envio, verifique o endereço e tente novamente.',
    google: 'Foi útil? Adoraríamos uma avaliação no Google',
    googleBtn: '⭐ Deixar uma avaliação',
    expired: 'Este link expirou (válido por 30 dias). Para receber a transcrição escreva para',
    invalid: 'Link inválido.',
    aiNote: 'Transcrição gerada automaticamente a partir da gravação da chamada, conforme anunciado no início. O resumo e a transcrição são realizados com o auxílio de inteligência artificial: alguns termos ou conceitos podem não refletir fielmente a conversa.',
    privacy: 'Política de privacidade',
    error: 'Ocorreu um erro, tente novamente dentro de instantes.',
  },
  nl: {
    title: 'Uw gesprek met Holiday World',
    callOf: 'Gesprek van',
    operator: 'Medewerker',
    gate: 'Om het volledige transcript te bekijken, vragen we u eerst om een korte beoordeling van het gesprek:',
    tap: 'Tik op een ster om te beoordelen',
    commentLabel: 'Wilt u meer kwijt? (optioneel)',
    commentPh: 'Uw opmerking...',
    submit: 'Versturen en transcript tonen',
    gateVote: 'Geef ons een korte beoordeling van uw gesprek met ons:',
    submitVote: 'Beoordeling versturen',
    showTx: '📄 Toon ook het volledige transcript',
    sending: 'Versturen...',
    thanks: 'Bedankt voor uw beoordeling!',
    summaryTitle: 'In het kort',
    transcriptTitle: 'Volledig transcript',
    pdf: '📄 PDF downloaden',
    emailAsk: 'Wilt u de samenvatting en het transcript ook per e-mail ontvangen?',
    emailPh: 'uw-email@voorbeeld.nl',
    emailBtn: 'Stuur mij de e-mail',
    emailSending: 'Versturen...',
    emailSent: '✓ E-mail verzonden! Controleer uw inbox (en de spammap).',
    emailErr: 'Versturen mislukt, controleer het adres en probeer opnieuw.',
    google: 'Was het nuttig? Wij zouden een Google-review zeer waarderen',
    googleBtn: '⭐ Review achterlaten',
    expired: 'Deze link is verlopen (30 dagen geldig). Schrijf voor het transcript naar',
    invalid: 'Ongeldige link.',
    aiNote: 'Transcript automatisch gegenereerd op basis van de gespreksopname, zoals aangekondigd aan het begin van het gesprek. De samenvatting en het transcript worden gemaakt met behulp van kunstmatige intelligentie: sommige termen of begrippen kunnen het gesprek niet perfect weergeven.',
    privacy: 'Privacybeleid',
    error: 'Er is iets misgegaan, probeer het zo opnieuw.',
  },
  pl: {
    title: 'Państwa rozmowa z Holiday World',
    callOf: 'Rozmowa z dnia',
    operator: 'Operator',
    gate: 'Aby zobaczyć pełną transkrypcję, prosimy najpierw o krótką ocenę rozmowy:',
    tap: 'Dotknij gwiazdki, aby ocenić',
    commentLabel: 'Chcą Państwo dodać coś więcej? (opcjonalnie)',
    commentPh: 'Państwa komentarz...',
    submit: 'Wyślij i pokaż transkrypcję',
    gateVote: 'Prosimy o krótką ocenę rozmowy z nami:',
    submitVote: 'Wyślij ocenę',
    showTx: '📄 Pokaż także pełną transkrypcję',
    sending: 'Wysyłanie...',
    thanks: 'Dziękujemy za ocenę!',
    summaryTitle: 'W skrócie',
    transcriptTitle: 'Pełna transkrypcja',
    pdf: '📄 Pobierz PDF',
    emailAsk: 'Czy chcą Państwo otrzymać podsumowanie i transkrypcję także e-mailem?',
    emailPh: 'twoj-email@przyklad.pl',
    emailBtn: 'Wyślij e-mail',
    emailSending: 'Wysyłanie...',
    emailSent: '✓ E-mail wysłany! Prosimy sprawdzić skrzynkę (także spam).',
    emailErr: 'Wysyłka nie powiodła się, prosimy sprawdzić adres i spróbować ponownie.',
    google: 'Czy to było pomocne? Będziemy wdzięczni za opinię w Google',
    googleBtn: '⭐ Zostaw opinię',
    expired: 'Ten link wygasł (ważny 30 dni). Aby otrzymać transkrypcję, prosimy napisać na',
    invalid: 'Nieprawidłowy link.',
    aiNote: 'Transkrypcja wygenerowana automatycznie z nagrania rozmowy, zgodnie z zapowiedzią na początku połączenia. Podsumowanie i transkrypcja powstają z pomocą sztucznej inteligencji: niektóre terminy lub treści mogą nie odzwierciedlać idealnie rozmowy.',
    privacy: 'Polityka prywatności',
    error: 'Wystąpił błąd, prosimy spróbować za chwilę.',
  },
};

const STAR_LABELS = {
  it: ['Pessima', 'Scarsa', 'Sufficiente', 'Buona', 'Eccellente'],
  en: ['Very poor', 'Poor', 'Fair', 'Good', 'Excellent'],
  de: ['Sehr schlecht', 'Schlecht', 'Ausreichend', 'Gut', 'Ausgezeichnet'],
  fr: ['Très mauvaise', 'Mauvaise', 'Correcte', 'Bonne', 'Excellente'],
  es: ['Muy mala', 'Mala', 'Aceptable', 'Buena', 'Excelente'],
  pt: ['Muito má', 'Má', 'Razoável', 'Boa', 'Excelente'],
  nl: ['Zeer slecht', 'Slecht', 'Voldoende', 'Goed', 'Uitstekend'],
  pl: ['Bardzo słaba', 'Słaba', 'Dostateczna', 'Dobra', 'Doskonała'],
};

export default function TranscriptLanding() {
  const { token } = useParams();
  const voteOnly = new URLSearchParams(window.location.search).get('vote') === '1';
  const channel = new URLSearchParams(window.location.search).get('ch') === 'wa' ? 'wa' : 'email';
  const [state, setState] = useState('loading'); // loading | invalid | expired | rate | view
  const [showTx, setShowTx] = useState(!voteOnly);
  const [lang, setLang] = useState('it');
  const [meta, setMeta] = useState(null);
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [sending, setSending] = useState(false);
  const [data, setData] = useState(null);
  const [errMsg, setErrMsg] = useState('');
  const [reqEmail, setReqEmail] = useState('');
  const [emailStatus, setEmailStatus] = useState('idle'); // idle | sending | sent | error
  const t = I18N[lang] || I18N.en;

  const submitEmail = async () => {
    if (!reqEmail.includes('@') || emailStatus === 'sending') return;
    setEmailStatus('sending');
    try {
      const r = await axios.post(`${API}/transcript/${token}/email`, { email: reqEmail });
      setEmailStatus(r.data.ok ? 'sent' : 'error');
    } catch (_) {
      setEmailStatus('error');
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/transcript/${token}/meta`);
        if (!r.data.valid) {
          setState(r.data.reason === 'expired' ? 'expired' : 'invalid');
          return;
        }
        setLang(r.data.language || 'it');
        setMeta(r.data);
        if (r.data.already_rated) {
          const res = await axios.post(`${API}/transcript/${token}/rate`, {});
          setData(res.data);
          setStars(res.data.rating || 0);
          setState('view');
        } else {
          setState('rate');
        }
      } catch (_) {
        setState('invalid');
      }
    })();
  }, [token]);

  const submitRating = async () => {
    if (!stars || sending) return;
    setSending(true);
    setErrMsg('');
    try {
      const res = await axios.post(`${API}/transcript/${token}/rate`, { stars, comment, vote_only: voteOnly, channel });
      setData(res.data);
      setState('view');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      setErrMsg(e.response?.data?.detail || t.error);
    } finally {
      setSending(false);
    }
  };

  const Header = () => (
    <div className="rounded-t-2xl px-6 py-7 text-center" style={{ background: '#1e3a8a' }}>
      <img
        src="https://www.holidayworld.it/wp-content/uploads/2018/05/Logo-new1.png"
        alt="Holiday World"
        className="inline-block h-12 w-auto bg-white rounded-xl px-4 py-2"
      />
      <p className="mt-2 text-white text-[11px] font-bold tracking-[2px] uppercase opacity-90">by Holiday World</p>
      <h1 className="mt-3 text-blue-100 text-base font-semibold">{t.title}</h1>
      {meta && (
        <p className="mt-1 text-blue-200 text-sm" data-testid="transcript-call-info">
          {t.callOf} <b>{meta.call_date || data?.call_date}</b>
          {(meta.operator_name || data?.operator_name) && <> · {t.operator}: <b>{meta.operator_name || data?.operator_name}</b></>}
        </p>
      )}
    </div>
  );

  const Stars = ({ interactive }) => (
    <div className="flex justify-center gap-1.5" data-testid="transcript-stars">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          data-testid={`transcript-star-${n}`}
          disabled={!interactive}
          onClick={() => interactive && setStars(n)}
          onMouseEnter={() => interactive && setHover(n)}
          onMouseLeave={() => interactive && setHover(0)}
          className={`text-4xl leading-none transition-transform ${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} ${
            n <= (hover || stars) ? 'text-amber-400' : 'text-slate-300'
          }`}
          aria-label={`${n} stelle`}
        >
          ★
        </button>
      ))}
    </div>
  );

  if (state === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-900" />
      </div>
    );
  }

  if (state === 'invalid' || state === 'expired') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
        <div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-8 text-center" data-testid="transcript-error-card">
          <div className="text-4xl mb-3">{state === 'expired' ? '⏰' : '🔒'}</div>
          {state === 'expired' ? (
            <p className="text-slate-700 text-sm" data-testid="transcript-expired-message">
              {I18N.it.expired} <a href="mailto:customerservice@holidayw.eu" className="text-blue-700 font-semibold">customerservice@holidayw.eu</a>.
              <br /><br /><span className="text-slate-400">{I18N.en.expired} customerservice@holidayw.eu.</span>
            </p>
          ) : (
            <p className="text-slate-700 text-sm" data-testid="transcript-invalid-message">
              {I18N.it.invalid} <span className="text-slate-400">/ {I18N.en.invalid}</span>
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 py-8 px-3" data-testid="transcript-landing">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        <Header />

        {state === 'rate' && (
          <div className="px-6 py-8" data-testid="transcript-rate-section">
            <p className="text-slate-700 text-[15px] text-center leading-relaxed">{voteOnly ? t.gateVote : t.gate}</p>
            <div className="mt-6">
              <Stars interactive />
              <p className="text-center text-xs text-slate-400 mt-2 h-4" data-testid="transcript-star-label">
                {stars || hover ? (STAR_LABELS[lang] || STAR_LABELS.en)[(hover || stars) - 1] : t.tap}
              </p>
            </div>
            <div className="mt-5 max-w-md mx-auto">
              <label className="block text-xs font-medium text-slate-500 mb-1">{t.commentLabel}</label>
              <textarea
                data-testid="transcript-comment-input"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder={t.commentPh}
                rows={3}
                maxLength={2000}
                className="w-full border border-slate-200 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-800"
              />
            </div>
            {errMsg && <p className="text-center text-red-600 text-sm mt-3" data-testid="transcript-rate-error">{errMsg}</p>}
            <div className="mt-5 text-center">
              <button
                data-testid="transcript-rate-submit"
                onClick={submitRating}
                disabled={!stars || sending}
                className={`px-7 py-3 rounded-lg text-white text-sm font-bold transition-opacity ${
                  !stars || sending ? 'bg-slate-300 cursor-not-allowed' : 'bg-blue-900 hover:opacity-90'
                }`}
              >
                {sending ? t.sending : (voteOnly ? t.submitVote : t.submit)}
              </button>
            </div>
          </div>
        )}

        {state === 'view' && data && (
          <div className="px-6 py-7" data-testid="transcript-view-section">
            <div className="text-center">
              <p className="text-emerald-700 font-semibold text-sm" data-testid="transcript-thanks">✓ {t.thanks}</p>
              <div className="mt-2"><Stars interactive={false} /></div>
            </div>

            {data.google_review_url && (
              <div className="mt-5 bg-amber-50 border border-amber-200 rounded-xl p-4 text-center" data-testid="transcript-google-box">
                <p className="text-amber-900 text-sm font-medium">{t.google}</p>
                <a
                  href={data.google_review_url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="transcript-google-btn"
                  className="inline-block mt-2 bg-amber-500 text-white text-sm font-bold px-5 py-2 rounded-lg hover:opacity-90"
                >
                  {t.googleBtn}
                </a>
              </div>
            )}

            {data.ask_email && (
              <div className="mt-5 bg-emerald-50 border border-emerald-200 rounded-xl p-4" data-testid="transcript-email-box">
                <p className="text-emerald-900 text-sm font-medium">{t.emailAsk}</p>
                {emailStatus === 'sent' ? (
                  <p className="mt-2 text-emerald-700 text-sm font-semibold" data-testid="transcript-email-success">{t.emailSent}</p>
                ) : (
                  <>
                    <div className="mt-2 flex gap-2">
                      <input
                        type="email"
                        data-testid="transcript-email-input"
                        value={reqEmail}
                        onChange={(e) => setReqEmail(e.target.value)}
                        placeholder={t.emailPh}
                        className="flex-1 border border-emerald-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600"
                      />
                      <button
                        data-testid="transcript-email-submit"
                        onClick={submitEmail}
                        disabled={!reqEmail.includes('@') || emailStatus === 'sending'}
                        className={`px-4 py-2 rounded-lg text-white text-sm font-bold ${
                          !reqEmail.includes('@') || emailStatus === 'sending' ? 'bg-slate-300 cursor-not-allowed' : 'bg-emerald-600 hover:opacity-90'
                        }`}
                      >
                        {emailStatus === 'sending' ? t.emailSending : t.emailBtn}
                      </button>
                    </div>
                    {emailStatus === 'error' && (
                      <p className="mt-1.5 text-red-600 text-xs" data-testid="transcript-email-error">{t.emailErr}</p>
                    )}
                  </>
                )}
              </div>
            )}

            {data.summary && (
              <div className="mt-6 bg-sky-50 border-l-4 border-sky-600 rounded-r-xl p-4" data-testid="transcript-summary">
                <p className="text-sky-900 text-xs font-bold uppercase mb-2">{t.summaryTitle}</p>
                {data.summary.split('\n').filter(Boolean).map((line, i) => (
                  <p key={i} className="text-slate-700 text-sm leading-relaxed my-0.5">{line}</p>
                ))}
              </div>
            )}

            {showTx ? (
              <>
                <div className="mt-6 flex items-center justify-between">
                  <p className="text-slate-400 text-xs font-bold uppercase">{t.transcriptTitle}</p>
                  <a
                    href={`${API}/transcript/${token}/pdf`}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="transcript-pdf-btn"
                    className="bg-blue-900 text-white text-xs font-bold px-4 py-2 rounded-lg hover:opacity-90"
                  >
                    {t.pdf}
                  </a>
                </div>
                <div className="mt-2 bg-slate-50 border border-slate-200 rounded-xl p-4 max-h-[28rem] overflow-y-auto" data-testid="transcript-text">
                  {data.transcript.split('\n').filter(Boolean).map((p, i) => (
                    <p key={i} className="text-slate-600 text-[13px] leading-relaxed my-1.5">{p}</p>
                  ))}
                </div>
              </>
            ) : (
              <div className="mt-6 text-center">
                <button
                  data-testid="transcript-show-btn"
                  onClick={() => setShowTx(true)}
                  className="bg-white border-2 border-blue-900 text-blue-900 text-sm font-bold px-5 py-2.5 rounded-lg hover:bg-blue-50"
                >
                  {t.showTx}
                </button>
              </div>
            )}

            <p className="mt-5 text-[11px] text-slate-400 leading-relaxed border-t border-slate-100 pt-3">
              {t.aiNote}{' '}
              <a href="https://hwsmart.it/privacy" className="text-blue-700">{t.privacy}</a> ·{' '}
              <a href="mailto:customerservice@holidayw.eu" className="text-blue-700">customerservice@holidayw.eu</a>
            </p>
          </div>
        )}

        <div className="bg-slate-900 px-6 py-4 text-center">
          <p className="text-white text-sm font-bold">Holiday World</p>
          <p className="text-slate-400 text-xs mt-1">
            <a href="mailto:customerservice@holidayw.eu" className="text-sky-300">customerservice@holidayw.eu</a>
            {' '}·{' '}
            <a href="https://www.holidayworld.it" className="text-sky-300">www.holidayworld.it</a>
          </p>
        </div>
      </div>
    </div>
  );
}
